import { Route } from 'react-router-dom';
import { listeNoireUserSchema } from './listNoire';
import { listeNoireUserAdminSchema } from './listNoire.admin';
import Main from '@app/main/tables/Main';
import { useAuth } from '@app/system/context/authContext';
import { UserRoles } from '@app/api';

/**
 * Composant qui sélectionne le bon schéma en fonction du rôle de l'utilisateur
 */
const ListeNoireComponent = () => {
    const { getTokenInfo } = useAuth();
    const roles = getTokenInfo()?.roles;
    // need to switch to admin
    const isAdminOrUser =
        roles?.includes(UserRoles.ADMIN) || roles?.includes(UserRoles.USER);

    return (
        <Main
            key="liste-noire-collaborateur"
            pageConfig={
                isAdminOrUser ? listeNoireUserAdminSchema : listeNoireUserSchema
            }
        />
    );
};

/**
 * Routes configurées pour le module ListeNoire
 */
const ListeNoireRoutes = [
    // Route de liste (principale)
    <Route
        key="liste-noire-collaborateur"
        path="listeNoire"
        element={<ListeNoireComponent />}
    />,
];

export default ListeNoireRoutes;
